import './App.css';
import React, {Component, Fragment} from 'react';
import UnauthenticatedRouter from "./components/UnauthenticatedRouter";
import AuthenticatedRouter from "./components/AuthenticatedRouter";
import UserSessionService from './services/UserSessionService';
import {ToastContainer} from "react-toastify";
import DefaultLayout from "./components/DefaultLayout";
import {BrowserRouter} from "react-router-dom";
import "flag-icon-css/css/flag-icon.css";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: {},
            headerText: "",
            loginTimestamp: null
        };

        this.handleResize = this.handleResize.bind(this);
    }

    userHasAuthenticated() {
        this.setState({
            loginTimestamp: new Date()
        });
    }

    isMobile() {
        return window.innerWidth < 575;
    }

    handleResize() {
        this.setState({isMobile: this.isMobile});
    };

    componentDidMount() {
        if (window) window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        if (window) window.removeEventListener('resize', this.handleResize);
    }

    setSelectedScreen(screen) {
        this.setState({
            selectedScreen: screen
        })
    }

    render() {
        return <BrowserRouter>
            {this.renderContent()}
        </BrowserRouter>
    }

    renderContent() {

        let authenticated = UserSessionService.isAuthenticated();
        let profile = UserSessionService.getCustomerProfile();

        let sharedChildProps = {
            isMobile: this.isMobile(),
            isAuthenticated: authenticated,
            userHasAuthenticated: this.userHasAuthenticated.bind(this)
        };

        if (authenticated && profile) {
            let authenticatedChildProps = {
                ...sharedChildProps,
                customer: profile,
                setSelectedScreen: this.setSelectedScreen.bind(this),
                setHeader: (header) => {
                    this.setState({
                        headerText: header
                    })
                }
            };

            return <Fragment>
                <DefaultLayout
                    headerText={this.state.headerText}
                    selectedScreen={this.state.selectedScreen}
                    customer={profile}
                    isMobile={this.isMobile()}
                    setSelectedScreen={this.setSelectedScreen.bind(this)}
                >
                    <ToastContainer position="top-right" autoClose={5000} style={{
                        zIndex: 1999,
                        width: "100%",
                        maxWidth:"500px"
                    }}/>
                    <AuthenticatedRouter
                        childProps={authenticatedChildProps}
                    />
                </DefaultLayout>
            </Fragment>
        } else {

            let unauthenticatedChildProps = {
                ...sharedChildProps
            };
            return <Fragment>
                <ToastContainer position="top-right" autoClose={5000} style={{
                    zIndex: 1999,
                    width: "100%",
                    maxWidth:"500px"
                }}/>
                <UnauthenticatedRouter
                    childProps={unauthenticatedChildProps}
                />
            </Fragment>
        }

    }
}

export default App;
